var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondaryaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.6667C18.9205 19.6667 19.6666 18.9205 19.6666 18C19.6666 17.0795 18.9205 16.3333 18 16.3333C17.0795 16.3333 16.3333 17.0795 16.3333 18C16.3333 18.9205 17.0795 19.6667 18 19.6667Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.8333C18.9205 13.8333 19.6666 13.0871 19.6666 12.1667C19.6666 11.2462 18.9205 10.5 18 10.5C17.0795 10.5 16.3333 11.2462 16.3333 12.1667C16.3333 13.0871 17.0795 13.8333 18 13.8333Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25.5C18.9205 25.5 19.6666 24.7538 19.6666 23.8333C19.6666 22.9129 18.9205 22.1667 18 22.1667C17.0795 22.1667 16.3333 22.9129 16.3333 23.8333C16.3333 24.7538 17.0795 25.5 18 25.5Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryaction);
export default __webpack_public_path__ + "static/media/✳️ secondary action.57a5691f5b6f0052865c6714fed78434.svg";
export { ForwardRef as ReactComponent };